import {CurrencyCode, currencyFormatPrice, currencyGetSymbolForDisplay} from '@wix/devzai-utils-common';

export interface DoppeActionPrice {
    actualPrice: number;
    discountPrice?: number;
    currencyCode: CurrencyCode;
}

export function doppeActionPriceGetActualPrice (actionPriceData: DoppeActionPrice) {
    return actionPriceData.actualPrice
}

export function doppeActionPriceGetDiscountPrice (actionPriceData: DoppeActionPrice) {
    return actionPriceData.discountPrice
}

export function doppeActionPriceGetCurrencySymbol (actionPriceData: DoppeActionPrice) {
    return  currencyGetSymbolForDisplay(actionPriceData.currencyCode)
}

export function doppeActionPriceGetFormattedPrice (actionPriceData: DoppeActionPrice) {
    return  currencyFormatPrice({
        code: actionPriceData.currencyCode,
        price: actionPriceData.actualPrice,
        removeFractionWhenPossible: true
    })
}